import Button from "components/button/default";
import "./roominf.scss";

type IProps = {
  count: number;
  disabled?: boolean;
  handleIncrease(): void;
  handleDecrease(): void;
};

export default function CounterControls({
  count,
  disabled = count === 1,
  handleIncrease,
  handleDecrease,
}: IProps) {
  return (
    <div className="counter-controls">
      <Button
        styels="minus"
        disabled={disabled}
        onClick={handleDecrease}
        text={""}
      />
      <h3>{count}</h3>
      <Button styels="plus" onClick={handleIncrease} text={""} />
    </div>
  );
}
